export default "__VITE_ASSET__B1jW8_Hh__"